// De una URL firmada de Supabase Storage a su ruta — ADR-2026-11-03-traer-de-atlas-sin-bajar-y-subir.
//
// Las creaciones de "Atlas" (Archivos → Atlas) llegan al editor sólo como URL firmada
// (`HistorialVideo.videoUrl`, la `imageUrl` de la grilla), sin la ruta del archivo. Con
// la ruta se puede COPIAR el archivo dentro de Storage en vez de bajarlo entero al
// navegador y volver a subirlo, y pedir la versión `full/` de una imagen en vez de la
// miniatura `opt/` de la grilla. Se saca de la URL para no tocar `productsApi`, que
// comparte la web entera.

/**
 * La ruta dentro del bucket, o null si la URL no es una firma de ESE bucket.
 * `https://x.supabase.co/storage/v1/object/sign/generadas/emp/full/a.mp4?token=…`
 * → `emp/full/a.mp4`.
 */
export function rutaDeUrlFirmada(url: string, bucket: string): string | null {
  try {
    const { pathname } = new URL(url);
    const prefijo = `/storage/v1/object/sign/${bucket}/`;
    if (!pathname.startsWith(prefijo)) return null;
    const ruta = decodeURIComponent(pathname.slice(prefijo.length));
    return ruta.length > 0 ? ruta : null;
  } catch {
    return null;
  }
}

/**
 * La versión en tamaño original de una miniatura de `generadas`: `emp/opt/a.png` →
 * `emp/full/a.png`. null si la ruta no es una miniatura `opt/`.
 */
export function rutaFullDeOpt(ruta: string): string | null {
  const m = /^([^/]+)\/opt\/(.+)$/.exec(ruta);
  return m ? `${m[1]}/full/${m[2]}` : null;
}
